import { render } from "./DegreeView.vue?vue&type=template&id=2b20ac82"
import script from "./DegreeView.vue?vue&type=script&lang=js"
export * from "./DegreeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__